import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../config";


function CleaningSwapPayment() {
  const { id } = useParams(); // dealId
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    async function startPayment() {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/api/cleaning/swaps/pay`,
          { swapId: id },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (!res.data?.url) {
          alert("Failed to start payment");
          navigate(-1);
          return;
        }

        // 🔁 Redirect to Stripe Checkout
        window.location.href = res.data.url;
      } catch (err) {
        console.error("❌ Cleaning swap payment error:", err);
        alert("Payment failed to start");
        navigate(-1);
      }
    }

    startPayment();
  }, [id, token, navigate]);

  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h2 style={{ color: "#2e7d32" }}>Redirecting to payment…</h2>
      <p>Please wait.</p>
    </div>
  );
}

export default CleaningSwapPayment;
